import { retryDynamicImport } from "@shared/lib"
import { transactions } from "@shared/routes"
import { RouteObject } from "react-router-dom"

export default [
	{
		path: transactions,
		children: [
			{
				index: true,
				lazy: () =>
					retryDynamicImport(() => import("../overview/ui")).then(
						m => ({
							Component: m.TransactionsOverview,
						}),
					),
			},
		],
	},
] satisfies RouteObject[]
